export enum ViewType {
	LIST = 'List',
	DETAIL = 'Detail',
	CREATING = 'Creating',
}
